import { format } from 'date-fns';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Colors } from '~/themes/colors';

interface IReadOnlyDatePillProps {
  date: Date;
}

export const ReadOnlyDatePill = ({ date }: IReadOnlyDatePillProps) => (
  <div
    data-testid="read-only-date-pill"
    data-cy="read-only-date-pill"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '8px 16px',
      borderRadius: 24,
      border: `1.5px solid ${colors.secondary[500]}`,
      backgroundColor: Colors.secondary_25,
    }}
  >
    <Typography as="span" variant="body1" color={colors.neutral[400]}>
      {format(date, 'EEE, MMM dd, yyyy')}
    </Typography>
  </div>
);
